<div class="p-sub-column-layout02__body-item" *ngIf="showHiddenMenu">
  <!-- [1.3.1] 旅程操作メニュー -->
  <ul class="p-sub-column-layout02__list" *ngIf="configObj.isItineraryMenuByScreenShow && isItineraryMenuByScreenShow">
    <!-- [1.3.3] 予約変更 -->
    <li class="p-sub-column-layout02__list-item" *ngIf="configObj.isReservationChangeShow">
      <a
        href="javascript:void(0)"
        class="p-sub-column-layout02__list-link"
        id="02{{ getDynamicId() }}"
        (click)="clickChange()"
      >
        {{ 'label.change1' | staticMsg }}</a
      >
    </li>
    <!-- /[1.3.3] 予約変更 -->

    <!-- [1.3.4] Acknowledge -->
    <li class="p-sub-column-layout02__list-item" *ngIf="configObj.isAcknowledgeShow">
      <a
        href="javascript:void(0)"
        class="p-sub-column-layout02__list-link"
        id="03{{ getDynamicId() }}"
        (click)="clickAcknowledge()"
        >{{ 'label.acknowledge' | staticMsg }}</a
      >
    </li>
    <!-- /[1.3.4] Acknowledge -->

    <!-- [1.3.5] Self Reaccommodation -->
    <li class="p-sub-column-layout02__list-item" *ngIf="configObj.isSelfReaccommodationShow">
      <a
        href="javascript:void(0)"
        class="p-sub-column-layout02__list-link"
        id="04{{ getDynamicId() }}"
        (click)="clickSelfReaccommodation()"
        >{{ 'label.selfReaccommodation' | staticMsg }}</a
      >
    </li>
    <!-- /[1.3.5] Self Reaccommodation -->

    <!-- [1.3.6] 解約 -->
    <li class="p-sub-column-layout02__list-item" *ngIf="configObj.isCancellationShow">
      <a
        href="javascript:void(0)"
        class="p-sub-column-layout02__list-link"
        id="05{{ getDynamicId() }}"
        (click)="clickCancel()"
        >{{ 'label.cancel' | staticMsg }}</a
      >
    </li>
    <!-- /[1.3.6] 解約 -->

    <!-- [1.3.7] 領収書 -->
    <li class="p-sub-column-layout02__list-item" *ngIf="configObj.isReceiptShow">
      <a
        href="javascript:void(0)"
        class="p-sub-column-layout02__list-link"
        id="06{{ getDynamicId() }}"
        (click)="clickReceipt()"
        >{{ 'heading.receipt' | staticMsg }}</a
      >
    </li>
    <!-- /[1.3.7] 領収書 -->

    <!-- [1.3.9] 旅程共有 -->
    <li class="p-sub-column-layout02__list-item" *ngIf="configObj.isItinerarySharingShow">
      <a
        href="javascript:void(0)"
        class="p-sub-column-layout02__list-link"
        id="08{{ getDynamicId() }}"
        [innerHTML]="'label.shareItinerary1' | staticMsg"
        (click)="clickShareItinerary()"
      ></a>
    </li>
    <!-- /[1.3.9] 旅程共有 -->
  </ul>
  <!-- /[1.3.1] 旅程操作メニュー -->
</div>
